// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-18c6ad6a] {\n  display: flex;\n  flex-direction: column;\n  font-size: 12px;\n  background-color: black;\n  color: #FFF;\n}\n.content[data-v-18c6ad6a] {\n  padding-left: 3.2vw;\n  padding-right: 3.2vw;\n  color: #070707;\n}\n.login[data-v-18c6ad6a] {\n  color: #007aff;\n}", ""]);
// Exports
module.exports = exports;
